<template>
  <div>
    <assign-sidebar :name="budgetAssign" :item="selected" @refresh="getData()" />
    <vs-card style="min-height: 100px" class="px-2">
      <vs-row>
        <vs-col vs-justify="center" vs-align="center" vs-w="4" vs-xs="12" class="p-2">
          <div class="flex mb-1">
            <label for="">{{ $t('entity') | capitalize }}</label>
          </div>
          <v-select :options="entities" :reduce="(el) => el.id" label="name" v-model="filter.entity" class="w-full"
            @input="getData()" />
        </vs-col>
        <vs-col vs-justify="center" vs-align="center" vs-w="4" vs-xs="12" class="p-2">
          <div class="flex mb-1">
            <label for="">{{ $t('departament') | capitalize }}</label>
          </div>
          <v-select :options="departaments" :reduce="(el) => el.id" label="name" v-model="filter.departament"
            class="w-full" @input="getData()" />
        </vs-col>
        <vs-col vs-justify="center" vs-align="center" vs-w="4" vs-xs="12" class="p-2">
          <div class="flex mb-1">
            <label for="">{{ $t('year') | capitalize }}</label>
          </div>
          <v-select :options="years" label="year" v-model="filter.year" class="w-full" @input="getData()" />
        </vs-col>
      </vs-row>
    </vs-card>
    <vs-row>
      <vs-col vs-w="4" class="pr-1">
        <statistics-card class="mb-base" icon="DollarSignIcon" title="USD" :statistic="getTotalColumn('usd')"
          color="#3498db" />
      </vs-col>
      <vs-col vs-w="4" class="px-2">
        <statistics-card class="mb-base" icon="DollarSignIcon" title="MXN" :statistic="getTotalColumn('mxn')"
          color="#28C76F" />
      </vs-col>
      <vs-col vs-w="4" class="pl-1">
        <statistics-card class="mb-base" icon="DollarSignIcon" title="USD EST" :statistic="getTotalColumn('usd_est')"
          color="#FF9F43" />
      </vs-col>
    </vs-row>
    <departament-table @edit="edit" :data="data" :loading="loading" class="px-4" />
  </div>
</template>
<script>
import DepartamentTable from './components/DepartamentTable.vue'
import AssignSidebar from './components/AssignSidebar.vue'
import StatisticsCard from '@/views/components/StatisticsCard.vue'


import vSelect from 'vue-select'
import request from './request.js'

export default {
  components: {
    'v-select': vSelect,
    DepartamentTable,
    StatisticsCard,
    AssignSidebar
  },
  data() {
    return {
      entities: [],
      departaments: [],
      years: [],
      filter: {
        year: null,
        entity: null,
        departament: null,
      },
      data: [],
      selected: {
        category_name: '',
        category_id: '',
        entity_id: '',
        departament_id: '',
        year: '',
      },
      budgetAssign: 'budget-assign-sidebar',
      loading: false
    }
  },
  methods: {
    edit(item) {
      const { category_id, category_name } = item
      this.selected = {
        category_name: category_name,
        category_id: category_id,
        year: this.filter.year,
        entity_id: this.filter.entity,
        departament_id: this.filter.departament,
      }
      this.$store.dispatch('toggleSidebar', this.budgetAssign)
    },
    getTotalColumn(column) {
      return this.data.length === 0 ? 0 : this.formatNumber(this.data.reduce((a, c) => Number(a) + Number(c[column]), 0), 2)
    },
    getEntities() {
      request
        .getEntities()
        .then((response) => {
          this.entities = [...response.data]
        })
        .catch((error) => {
          this.showValidationErrors(error)
        })
    },
    getDepartaments() {
      request
        .getDepartaments()
        .then((response) => {
          this.departaments = [...response.data]
        })
        .catch((error) => {
          this.showValidationErrors(error)
        })
    },
    getYears() {
      request
        .getYears()
        .then((response) => {
          this.years = response.data.map(function (obj) {
            return obj.year
          })
        })
        .catch((error) => {
          this.showValidationErrors(error)
        })
    },
    getData() {
      if (this.filter.year == null || this.filter.entity == null || this.filter.departament == null) {
        return
      }
      const payload = {
        year: this.filter.year,
        entity_id: this.filter.entity,
        departament_id: this.filter.departament,
      }
      this.data = []
      this.loading = true
      request
        .list(payload)
        .then((response) => {
          this.data = [...response.data]
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          //this.showValidationErrors(error)
        })

    },
  },
  mounted() {
    this.getEntities()
    this.getDepartaments()
    this.getYears()
  },
}
</script>

<style>
.vs__dropdown-menu {
  max-height: 50px;
}
</style>
